import { Fetcher, SWRResponse } from 'swr'
import useSWRImmutable from 'swr/immutable'
import { client } from '~/api/client'
import { getOfficialRecommendedMembersV1, Schemas } from '~/api/gen'
import { JP_COUNTRY_ID } from '~/features/shared/country'
import { assertSuccess } from '~/lib/assertSuccess'

type PopularUsersKey = 'getOfficialRecommendedMembersV1'

const fetchPopularUsers: Fetcher<
  Schemas.get_official_recommended_members_v1_response,
  PopularUsersKey
> = async () => {
  const result = await getOfficialRecommendedMembersV1(client, {
    parameter: { count: 9, country_id: JP_COUNTRY_ID },
  })
  assertSuccess(result)

  return result.data
}

export const usePopularUsers = (): SWRResponse<
  Schemas.get_official_recommended_members_v1_response,
  Error
> => {
  const key: PopularUsersKey = 'getOfficialRecommendedMembersV1'
  return useSWRImmutable(key, fetchPopularUsers)
}
